import { render, staticRenderFns } from "./MtrbEdit.vue?vue&type=template&id=1f3ca1f8&scoped=true&"
import script from "./MtrbEdit.vue?vue&type=script&lang=js&"
export * from "./MtrbEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3ca1f8",
  null
  
)

export default component.exports